export function generatePolishCSS(): string {
  return `
/* ============================================
   QA: 2.1 — Consolidated Polish (Token-based)
   Replaces hardcoded Elite-Polish overrides
   ============================================ */

/* Typography: Premium Rendering */
body {
  text-rendering: optimizeLegibility;
  font-kerning: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* QA: VIS-2 — Global Heading Hierarchy */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-display);
  line-height: var(--leading-tight);
  letter-spacing: var(--tracking-tight);
  font-weight: var(--weight-bold);
}

/* QA: D-2 — Prose-Text Lesebreite (Bringhurst 45–75ch) */
.hero__text,
.service-card p,
.benefit p,
.testimonial__quote,
.faq-item__answer,
.cta p {
  max-width: 65ch;
}

/* Section Spacing: Density-driven */
.services,
.benefits,
.team,
.testimonials,
.faq,
.cta {
  padding-top: var(--density-section-py);
  padding-bottom: var(--density-section-py);
}

/* Focus: Brand-consistent (tokenized) */
:focus-visible {
  outline: 3px solid rgba(var(--c-primary-rgb) / 0.35);
  outline-offset: 3px;
}

/* Nav Links: Editorial Underline */
.header__nav-link:hover,
.nav-link:hover {
  text-decoration: underline;
  text-underline-offset: 6px;
  text-decoration-thickness: 2px;
}

/* Dark Mode: Component Overrides */
.dark .service-card,
.dark .testimonial,
.dark .cookie-banner {
  background: rgba(17, 24, 39, 0.82);
  border-color: rgba(255, 255, 255, 0.08);
}

.dark .hero__text,
.dark .hero p,
.dark .service-card p {
  color: var(--c-text-light);
}

/* QA: Wave 7 — Performance: content-visibility for below-fold */
.services, .benefits, .team, .testimonials, .faq, .gallery {
  content-visibility: auto;
  contain-intrinsic-size: auto 500px;
}

/* QA: Wave 6 — Print styles */
@media print {
  .header, .cookie-banner, .cookie-modal, .sticky-cta,
  .fx-grain-overlay, .fx-orbs,
  body::before { display: none !important; }
  body { background: #fff !important; color: #000 !important; }
  .hero::before, .hero::after, .cta::before, .cta::after { display: none; }
  .cta { background: #f4f4f5 !important; color: #000 !important; }
  .service-card, .testimonial { break-inside: avoid; box-shadow: none; border: 1px solid #ddd; }
  a[href]::after { content: ' (' attr(href) ')'; font-size: 0.8em; color: #666; }
  nav a[href]::after, .footer__social a::after { content: none; }
}

/* QA: Wave 5 — Scroll-reveal animations */
.services,
.benefits,
.team,
.testimonials,
.faq,
.cta {
  opacity: 0;
  transform: translateY(8px);
  transition: opacity var(--duration-slow) var(--ease-out),
              transform var(--duration-slow) var(--ease-out);
}
.is-visible {
  opacity: 1;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .services, .benefits, .team, .testimonials, .faq, .cta {
    opacity: 1;
    transform: none;
    transition: none;
  }
}

`;
}
